<template>
  <div>
    <b-form @submit="saveTarrif">
      <b-form-group label-align="right" label="ID" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="isEdit">
        <b-form-input type="text" required v-model="editTariff.id" disabled/>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Tariff name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input type="text" required v-model="newTariff.name"/>
      </b-form-group>
      <b-form-group label-align="right" :label="$t('Comments')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-input type="text" v-model="newTariff.comments"/>
      </b-form-group>
      <b-row v-if="isEdit">
        <b-col>
          <b-form-group :label="$t('Created on')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="text" v-model="editTariff.create_date" disabled/>
          </b-form-group>
          <b-form-group :label="$t('Last modified on')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="text" disabled v-model="editTariff.whoCreate"/>
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group :label="$t('Created by')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="text" disabled v-model="editTariff.change_date"/>
          </b-form-group>
          <b-form-group :label="$t('Modified by')" label-cols="4" label-cols-xl="4" label-cols-md="4">
            <b-form-input type="text" disabled v-model="editTariff.whoChange"/>
          </b-form-group>
        </b-col>
      </b-row>
      <b-form-group :label="$t('Zero balance at the accounting period end')" label-cols="4" label-cols-xl="4" label-cols-md="4">
        <b-form-checkbox v-model="newTariff.balance_rollover"/>
      </b-form-group>
      <b-form-group :label="$t('Services')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="isEdit">
        <b-button variant="success" style="float: right" size="sm" @click="showParentService">{{ $t('Add') }}</b-button>
      </b-form-group>
      <b-table striped hover small v-if="isEdit"
        :items="servicesTariffList"
        :fields="servicesTariffFields"/>
      <b-row>
        <b-col>
          <b-button variant="success" block type="submit">Ok</b-button>
        </b-col>
        <b-col>
          <b-button variant="secondary" block @click="hideTariffPlans">{{ $t('Cancel') }}</b-button>
        </b-col>
      </b-row>
    </b-form>

    <b-modal hide-footer :title="$t('Select parent service')" ref="modalParentServices">
      <b-table striped hover small
        :items="servicesTemplatesList"
        :fields="servicesTemplatesFields"
        selectable
        select-mode="single"
        @row-selected="rowClickedService"/>
      <b-row>
        <b-col>
          <b-button variant="success" block @click="showFormAddServices">Ok</b-button>
        </b-col>
        <b-col>
          <b-button variant="secondary" block @click="hideParentServices">{{ $t('Cancel') }}</b-button>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal hide-footer :title="$t('One-time service')" ref="modalOnceService">
      <FormOnceServices
      @hideModalServices="hideModalServices"
      @reload="load"
      :currentRowService="selectTemplatesService"
      :currentRowTariffPlans="currentRowTariffPlans"
      :isTariffPlan="isTariffPlan"/>
    </b-modal>

    <b-modal hide-footer :title="$t('Periodic service')" ref="modalPeriodicService">
      <FormPeriodicServices
      @hideModalServices="hideModalServices"
      @reload="load"
      :isTariffPlan="isTariffPlan"
      :currentRowService="selectTemplatesService"
      :currentRowTariffPlans="currentRowTariffPlans"/>
    </b-modal>

    <b-modal hide-footer :title="$t('IP traffic service')" ref="modalIPtrafficService" size="lg">
      <FormIPtrafficService
      @hideModalServices="hideModalServices"
      @reload="load"
      :isTariffPlan="isTariffPlan"
      :currentRowService="selectTemplatesService"
      :currentRowTariffPlans="currentRowTariffPlans"/>
    </b-modal>

    <b-modal hide-footer :title="$t('Hotspot service')" ref="modalHotspotService" size="lg">
      <FormHotspotServices
      @hideModalServices="hideModalServices"
      @reload="load"
      :isTariffPlan="isTariffPlan"
      :currentRowService="selectTemplatesService"
      :currentRowTariffPlans="currentRowTariffPlans"/>
    </b-modal>

    <b-modal hide-footer :title="$t('Dial-up service')" ref="modalDialupService" size="lg">
      <FormDialupServices
      @hideModalServices="hideModalServices"
      @reload="load"
      :isTariffPlan="isTariffPlan"
      :currentRowService="selectTemplatesService"
      :currentRowTariffPlans="currentRowTariffPlans"/>
    </b-modal>

    <b-modal hide-footer :title="$t('Telephony service')" ref="modalTelephoneService" size="lg">
      <FormTelephoneService
      @hideModalServices="hideModalServices"
      @reload="load"
      :isTariffPlan="isTariffPlan"
      :currentRowService="selectTemplatesService"
      :currentRowTariffPlans="currentRowTariffPlans"/>
    </b-modal>

    <b-modal hide-footer :title="$t('IPTV service')" ref="modalIPTVService" size="lg">
      <FormIPTVService
      @hideModalServices="hideModalServices"
      @reload="load"
      :isTariffPlan="isTariffPlan"
      :currentRowService="selectTemplatesService"
      :currentRowTariffPlans="currentRowTariffPlans"/>
    </b-modal>

    <b-modal hide-footer :title="$t('Video on demand')" ref="modalVodService" size="lg">
      <FormVodService
      @hideModalServices="hideModalServices"
      @reload="load"
      :isTariffPlan="isTariffPlan"
      :currentRowService="selectTemplatesService"
      :currentRowTariffPlans="currentRowTariffPlans"/>
    </b-modal>
  </div>
</template>

<script>

import axiosInstance from '@/utils/api.js'
import FormOnceServices from '@/pages/tariffication/servicesAndTariffs/formOnceService'
import FormPeriodicServices from '@/pages/tariffication/servicesAndTariffs/formPeriodicService'
import FormIPtrafficService from '@/pages/tariffication/servicesAndTariffs/formIPtrafficService'
import FormHotspotServices from '@/pages/tariffication/servicesAndTariffs/formHotspotService'
import FormDialupServices from '@/pages/tariffication/servicesAndTariffs/formDialupService'
import FormTelephoneService from '@/pages/tariffication/servicesAndTariffs/formTelephonyService'
import FormIPTVService from '@/pages/tariffication/servicesAndTariffs/formIPTVService'
import FormVodService from '@/pages/tariffication/servicesAndTariffs/formVodService'

export default {
  components: {
    FormOnceServices,
    FormPeriodicServices,
    FormIPtrafficService,
    FormHotspotServices,
    FormDialupServices,
    FormTelephoneService,
    FormIPTVService,
    FormVodService
  },
  props: {
    isEdit: null,
    currentRowTariffPlans: null
  },
  data () {
    return {
      isTariffPlan: false,
      selectTemplatesService: null,
      editTariff: {
        'whoChange': '',
        'whoCreate': '',
        'create_date': '',
        'change_date': '',
        'id': 0
      },
      newTariff: {
        'tariff_id': 0,
        'name': '',
        'balance_rollover': 0,
        'comments': ''
      },
      tmpTariff: {
        'name': '',
        'balance_rollover': 0,
        'comments': ''
      },
      servicesList: [],
      servicesTariffList: [],
      servicesTariffFields: [
        {key: 'service_id', label: 'ID', sortable: true},
        {key: 'nameServicesType', label: this.$i18n.t('Type'), sortable: true},
        {key: 'service_name', label: this.$i18n.t('Full name'), sortable: true},
        {key: 'comment', label: this.$i18n.t('Comment'), sortable: true}
      ],
      servicesTemplatesList: [],
      servicesTemplatesFields: [
        {key: 'service_id', label: 'ID', sortable: true},
        {key: 'nameServicesType', label: this.$i18n.t('Type'), sortable: true},
        {key: 'service_name', label: this.$i18n.t('Full name'), sortable: true},
        {key: 'comment', label: this.$i18n.t('Comment'), sortable: true}
      ]
    }
  },
  methods: {
    hideModalServices () {
      this.$refs.modalOnceService.hide()
      this.$refs.modalPeriodicService.hide()
      this.$refs.modalDialupService.hide()
      this.$refs.modalHotspotService.hide()
      this.$refs.modalIPTVService.hide()
      this.$refs.modalVodService.hide()
      this.$refs.modalIPtrafficService.hide()
      this.$refs.modalTelephoneService.hide()
    },
    rowClickedService (row) {
      this.selectTemplatesService = row[0]
    },
    showParentService () {
      this.selectTemplatesService = null
      this.$refs.modalParentServices.show()
    },
    hideParentServices () {
      this.$refs.modalParentServices.hide()
    },
    hideTariffPlans () {
      this.$emit('hideTariffPlans')
    },
    showFormAddServices () {
      if (!this.selectTemplatesService) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select service'), 'Error')
        return
      }
      for (let el of this.servicesTariffList) {
        if (el.parent_id === this.selectTemplatesService.parent_id) {
          this.$root.$emit('makeToasts', 'danger', this.$i18n.t('This parental service is already used in the tariff plan'), 'Error')
          return
        }
      }
      this.isTariffPlan = true
      switch (this.selectTemplatesService.service_type) {
        case 1:
          this.$refs.modalOnceService.show()
          break
        case 2:
          this.$refs.modalPeriodicService.show()
          break
        case 3:
          this.$refs.modalIPtrafficService.show()
          break
        case 4:
          this.$refs.modalHotspotService.show()
          break
        case 5:
          this.$refs.modalDialupService.show()
          break
        case 6:
          this.$refs.modalTelephoneService.show()
          break
        case 8:
          this.$refs.modalIPTVService.show()
          break
        case 9:
          this.$refs.modalVodService.show()
          break
      }
      this.hideParentServices()
    },
    saveTarrif () {
      if (this.newTariff.balance_rollover) {
        this.newTariff.balance_rollover = 1
      } else {
        this.newTariff.balance_rollover = 0
      }
      if (this.isEdit) {
        this.newTariff.tariff_id = this.editTariff.id
        axiosInstance.put(this.$store.getters.API_TARIFFING_TARIFF, this.newTariff).then(response => {
          if (response.data.error) {
            this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
          } else {
            this.$root.$emit('makeToasts')
            setTimeout(this.$store.dispatch, 500, 'Tariffing/GET_TARIFFS')
            this.hideTariffPlans()
          }
        })
      } else {
        axiosInstance.post(this.$store.getters.API_TARIFFING_TARIFF, this.newTariff).then(response => {
          if (response.data.error) {
            this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
          } else {
            this.$root.$emit('makeToasts')
            setTimeout(this.$store.dispatch, 500, 'Tariffing/GET_TARIFFS')
            this.hideTariffPlans()
          }
        })
      }
    },
    async load () {
      if (this.isEdit) {
        let tariffId = this.currentRowTariffPlans.id
        this.newTariff.name = this.currentRowTariffPlans.name
        this.newTariff.comments = this.currentRowTariffPlans.comments
        this.editTariff.id = this.currentRowTariffPlans.id
        this.editTariff.whoChange = this.currentRowTariffPlans.whoChange
        this.editTariff.whoCreate = this.currentRowTariffPlans.whoCreate
        this.editTariff.create_date = this.currentRowTariffPlans.create_date
        this.editTariff.change_date = this.currentRowTariffPlans.change_date
        if (this.currentRowTariffPlans.balance_rollover) {
          this.newTariff.balance_rollover = true
        } else {
          this.newTariff.balance_rollover = false
        }
        this.servicesList = await axiosInstance.get(this.$store.getters.API_TARIFFING_SERVICES).then(response => { return response.data })
        for (let i in this.servicesList) {
          switch (this.servicesList[i].service_type) {
            case 1:
              this.servicesList[i].nameServicesType = this.$i18n.t('One-time service link')
              break
            case 2:
              this.servicesList[i].nameServicesType = this.$i18n.t('Periodic service link')
              break
            case 3:
              this.servicesList[i].nameServicesType = this.$i18n.t('IP traffic service link')
              break
            case 4:
              this.servicesList[i].nameServicesType = this.$i18n.t('Hotspot service link')
              break
            case 5:
              this.servicesList[i].nameServicesType = this.$i18n.t('Dial-up service link')
              break
            case 6:
              this.servicesList[i].nameServicesType = this.$i18n.t('Telephony service link')
              break
            case 8:
              this.servicesList[i].nameServicesType = this.$i18n.t('IPTV service link')
              break
            case 9:
              this.servicesList[i].nameServicesType = this.$i18n.t('Video service link')
              break
          }
        }
        this.servicesTariffList = this.servicesList.filter(function (value) {
          return value.tariff_id === tariffId
        })
        this.servicesTemplatesList = this.servicesList.filter(function (value) {
          return (value.parent_id !== 0 && value.tariff_id === 0)
        })
        for (let el of this.servicesTariffList) {
          this.servicesTemplatesList = this.servicesTemplatesList.filter(function (value) {
            return (value.parent_id !== el.parent_id)
          })
        }
        if (this.currentRowTariffPlans.id === 0) this.servicesTariffList = null
      } else {
        this.newTariff = JSON.parse(JSON.stringify(this.tmpTariff))
      }
    }
  },
  mounted () {
    this.load()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/tariffication/servicesAndTariffs/formTariffPlans.vue